var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TaskCardExpandedContent"},[_c('TaskInfo',{attrs:{"task":_vm.task}}),_c('TaskOptions',{attrs:{"task":_vm.task}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }